import type { TimelineEntity } from '@platform/timeline';

export type AddCmd<E extends TimelineEntity = TimelineEntity> = {
  kind: 'add';
  convId: string;
  entity: E;
};

export type UpsertCmd<E extends TimelineEntity = TimelineEntity> = {
  kind: 'upsert';
  convId: string;
  entity: E;
};

export type SemCmd = AddCmd | UpsertCmd;

export namespace Sem {
  export type Type = string; // canonical dotted type, e.g. "thinking.mode.started"
  export interface BaseEvent {
    type: Type;
    id: string;
    data?: unknown;
    metadata?: unknown;
  }
}

export type SemHandler = (args: {
  ev: Sem.BaseEvent;
  now: number;
  convId: string;
}) => SemCmd | null;

const handlers = new Map<string, SemHandler>();

export function registerSem(type: Sem.Type, handler: SemHandler): void {
  handlers.set(type, handler);
}

export function getSemHandler(type: string): SemHandler | undefined {
  return handlers.get(type);
}

export function clearSemHandlers(): void {
  handlers.clear();
}

export function listSemHandlers(): string[] {
  return Array.from(handlers.keys()).sort();
}

export function handleSem(args: {
  ev: Sem.BaseEvent;
  now: number;
  convId: string;
}): SemCmd | null | undefined {
  const h = getSemHandler(args.ev.type);
  if (!h) return undefined;
  try {
    return h(args);
  } catch {
    return null;
  }
}
